<template>
  <div class="dropdown">
    <div class="form-floating mb-3">
      <input
          class="form-control"
          :id="property"
          v-model="search"
          @input="onChange"
          type="text"
          :class="{'is-invalid': error }"
      >
      <label :for="property" class="form-label">{{ name }}<span class="text-danger" v-if="isRequired">*</span></label>
      <message-error :code="errorCode" :hasError="error"/>
    </div>
    <ul v-show="isOpen" class="dropdown-menu show" style="width: 100%">
      <li v-for="address in results" :key="address.properties.label">
        <a class="dropdown-item" @click="setResult(address.properties)">{{ address.properties.label }}</a>
      </li>
    </ul>

  </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'
import axios from "axios";

export default {
  name: 'AdressField',
  components: { MessageError },
  props:{
    value:{ type: String },
    name: { type: String },
    property: { type: String },
    error: {type: Boolean },
    isRequired: { type: Boolean },
    errorCode: { type: String }
  },
  watch:{
    value(val){
      this.search = val
    }
  },
  data(){
    return {
      search: '',
      isOpen: false,
      results: []
    }
  },
  methods:{
      onChange() {
        const here = this
        axios.get(
            'https://api-adresse.data.gouv.fr/search/?q=' +
            this.search.replaceAll(' ', '+') +
            '&type=housenumber&autocomplete=1', {transformRequest: (data, headers) => {
                delete headers.common['Authorization'];
              }
            })
            .then((r) => {
              here.results = r.data.features
              here.isOpen = true
            })
      },
      setResult(result) {
        const obj = {
          denomination: result.city + result.citycode
              .toLowerCase()
              .replaceAll(' ', '-')
              .replaceAll(/[^a-zA-Z0-9 ]/g, ""),
          city: result.city
        }

        this.$emit('infos',obj)

        this.search = result.label
        this.$emit('input',this.search)

        this.isOpen = false;
      }
  }
}
</script>

<style scoped>
input, .dropdown-menu {
  border-radius: 0 !important;
}
a {
  cursor: pointer;
}
</style>
